module.exports = __webpack_public_path__ + "img/dccbc12.webp";